import styled from "styled-components"
import {
    EmptySpan,
    TableRow,
    TableCell,
} from "client/components"

export const TableRowLevelStyled = styled(TableRow)`
    ${EmptySpan} {
        color: ${(props) => props.theme.tableSectionNotUsedColor} !important;
    }

    ${TableCell}:not(:first-child) {
        font-weight: normal;
    }
`
export const ModelTitle = styled.span`
    text-transform: uppercase;
`
export const DatapointRow = styled(TableRow)`
    background: ${(props) => props.theme.qidResultDatapointWrapperBackground};

    &:hover {
        background: ${(props) => props.theme.qidResultDatapointWrapperBackground};
    }
`
export const DatapointWrapper = styled.div`
    width: 100%;
    margin-bottom: 10px;
    border: 1px solid ${(props) => props.theme.qidDatapointBorderColor};

    &:last-child {
        margin-bottom: 0;
    }
`
